export const CHECKBOX_VALUES = {
    NO_SIGNATURE: 'noSignatureRequired',
    ONLY_RECEIVER: 'onlyReceiverSignatureRequired',
    ONLY_AGENCY: 'onlyAgencySignatureRequired',
    BOTH: 'eSignatureRequired',
}
